import React from "react";
import { Col, Row } from "antd";
import CustomInput from "../../common/input/custom-textfield/custom-textfield";
import CustomSelect from "../../common/input/custom-select/custom-select";
import CustomDatepicker from "../../common/input/custom-datepicker/custom-datepicker";
import dayjs from "dayjs";
import CustomUpload from "../../common/CustomUpload/CustomUpload";
import CustomAutoComplete from "../../common/input/custom-autocomplete/custom-autocomplete";
import styles from "./profile-form.module.css";

const ProfileForm = {};

ProfileForm.TextInput = ({ inputLabel, isEdit, required, ...inputProps }) => {
  return (
    <Row gutter={[12]} style={{ display: "flex", alignItems: "center" }}>
      <Col span={8} style={{ color: "#667085" }}>
        {inputLabel}:
        {isEdit && required ? (
            <span style={{ color: "red" }}>*</span>
        ) : null}
      </Col>
      <Col span={16}>
        {isEdit ? (
          <CustomInput size="large" {...inputProps} />
        ) : (
          inputProps.value || "-"
        )}
      </Col>
    </Row>
  );
};

ProfileForm.Select = ({ inputLabel, isEdit, children, required, ...inputProps }) => {
  return (
    <Row gutter={[12]} style={{ display: "flex", alignItems: "center" }}>
      <Col span={8} style={{ color: "#667085" }}>
        {inputLabel}:
        {isEdit && required ? (
            <span style={{ color: "red" }}>*</span>
        ) : null}
      </Col>
      <Col span={16}>
        {isEdit ? (
          <CustomSelect size="large" {...inputProps}>
            {children}
          </CustomSelect>
        ) : (
          inputProps.value || "-"
        )}
      </Col>
    </Row>
  );
};

ProfileForm.DatePicker = ({ inputLabel, isEdit, format, required, ...inputProps }) => {
  return (
    <Row gutter={[12]} style={{ display: "flex", alignItems: "center" }}>
      <Col span={8} style={{ color: "#667085" }}>
        {inputLabel}:
        {isEdit && required ? (
          <span style={{ color: "red" }}>*</span>
        ) : null}
      </Col>
      <Col span={16}>
        {isEdit ? (
          <CustomDatepicker size="large" {...inputProps} />
        ) : (
          inputProps.value ? dayjs(inputProps.value).format("DD-MM-YYYY") : "-"
        )}
      </Col>
    </Row>
  );
};

ProfileForm.Upload = ({ inputLabel, isEdit, value, required, ...inputProps }) => {
  return (
    <Row gutter={[12]} style={{ display: "flex", alignItems: "center" }}>
      <Col span={8} style={{ color: "#667085" }}>
        {inputLabel}:
        {isEdit && required ? (
          <span style={{ color: "red" }}>*</span>
        ) : null}
      </Col>
      <Col span={16}>
        {isEdit ? (
          <CustomUpload 
            accepts=".jpg, .png, .jpeg, .pdf" 
            fileName={value?.name}
            {...inputProps} 
          />
        ) : value?.url ? (
          <a
            href={value?.url}
            download
            className={styles.download_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {value?.name}
          </a>
        ) : (
          "-"
        )}
      </Col>
    </Row>
  );
};

ProfileForm.AutoComplete = ({ inputLabel, isEdit, ...inputProps }) => {
  return (
    <Row gutter={[12]} style={{ display: "flex", alignItems: "center" }}>
      <Col span={8} style={{ color: "#667085" }}>
        {inputLabel}:
      </Col>
      <Col span={16}>
        {isEdit ? (
          <CustomAutoComplete size="large" {...inputProps} />
        ) : (
          inputProps.value || "-"
        )}
      </Col>
    </Row>
  );
};


export default ProfileForm;
